import { useQuery } from '@tanstack/react-query';
import { AuditLogsService, GetListAuditLogEntity } from 'services/openapi';

import { AuditLogsServiceQueryKeys } from '../constants';
import { GetAuditLogsAdminDTO } from './useGetAuditLogsAdminQuery';

export const useGetAuditLogsAdminExportQuery = (
  variables: GetAuditLogsAdminDTO,
) => {
  const queryKey = [AuditLogsServiceQueryKeys.GET_AUDIT_LOGS_LIST, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListAuditLogEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      AuditLogsService.auditlogControllerListAuditLogs(
        variables.startDate,
        variables.endDate,
        variables.page,
        variables.pageSize,
        variables.actorId,
        variables.action,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
